import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import mx5 from "../../../../assets/info/mx5-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import styled from "styled-components";
import part1 from "../../../../assets/info/mazda-mx-5/803287_4.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";

const MazdaMX5 = () => {
  useSmallNav("Mazda MX5");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Mazda MX5"} bolder />
        <InfoHero image={mx5} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Do you own an MX5? Looking for suspension parts or suspension upgrades?"
              }
            />
            <p>Then you have arrived at the right place!</p>
            <p>
              Here at Pedders, we offer a range of suspension and brake parts
              for your MX5, both standard and modified.
            </p>
            <p>
              As well as offering springs and shocks, Pedders being both a
              spring and shock manufacturer, means we are able to bring to you,
              the Pedders Ezifit concept.
            </p>
            <p>
              What is Ezifit? Ezifit is a fully assembled spring and shock
              package supplied already assembled with spring, shock, top mount,
              bumpstop and boot. Ready to fit and fully warranted for 2 years or
              24,000 miles. Too Ezi!
            </p>
            <p>
              These are offered in both standard and lowered formats, so we have
              what you need, whether you are restoring your MX5 to “as original”
              or modifying it for improved looks or performance. Initially these
              are available for MK1 / NA models with MK2 / NB to follow soon.
            </p>
            <p>
              The standard version utilises standard style springs and shocks.
              Pedders shocks have had changes to the valving made for better
              control, but still offer a level of performance and ride similar
              to that originally fitted.
            </p>
            <p>
              The lowered version uses the same Pedders shocks with Pedders
              lowering springs for improved handling and looks.
            </p>
            <p>
              For the more hardcore, we also offer fully adjustable coilover
              kits for those using their cars for trackdays.
            </p>
            <p>
              If you don’t see what you need, or unsure which products suit you
              best, please do get in contact with one of our team who will
              assist you with your decision.
            </p>
            <Gray>
              <InfoHeader
                size="smaller"
                text={
                  "Restoring your NA MX5? Worn out coilovers? Just a freshen up?"
                }
              />
              <p>Our OEDR Ezifit struts are just what you need. Kit 803287</p>
              <p>
                Complete assemblies, ready to fit straight onto your car.
                Includes all new parts. Top mounts, bumpstop and boot, shock,
                spring, and for added refinement we also include spring
                insulator rubbers which the early cars didn’t get.
              </p>
              <p>Simply remove the old struts and fit the new ones. Too Ezi!</p>
              <p>
                Available as a complete kit of for struts at an exceptionally
                good price.
              </p>
              <div>
                <StyledImgParts src={part1} alt="Kit 803287" />
              </div>
            </Gray>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Mazda")
              .models.find((e) => e.display === "MX5")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        <InfoFooter make="Mazda" model="MX5" />
      </Container>
    </section>
  );
};

export default MazdaMX5;

const StyledImgParts = styled.img`
  width: 100%;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
